import styled from '@emotion/styled'

import { MainTitle } from '../../../components/styled'
import { MOBILE } from '../../../guided-toolbox/utils/breakpoints'

export const AccountSummaryPage = styled.div`
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;

  ${MOBILE} {
    /* Remove the side padding so cards can use the full screen width. */
    padding-left: 0;
    padding-right: 0;
  }
`

export const AccountSummaryTitle = styled(MainTitle)`
  margin-bottom: 25px;

  ${MOBILE} {
    margin-bottom: 20px;
    font-size: 30px;
    color: ${p => p.theme.darkestGray ?? '#022a3a'};
  }
`

export const CardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-bottom: 10px;

  ${MOBILE} {
    gap: 20px;
  }
`
